module.exports = __webpack_public_path__ + "img/AdobeStock_301790714.2f1e2f3a.jpeg";